import { combineReducers } from 'redux'

import user from './user/slice'
import airdrop from './airdrop/slice'

// app
import modal from 'modal/state/reducer'
import notifications from 'notifications/service/reducer'

import { feeDataApi } from './feeDataApi'
import { balancesApi } from './balancesApi'

export const rootReducer = combineReducers({
  user,
  airdrop,
  // app
  modal,
  notifications,
  // slices
  [balancesApi.reducerPath]: balancesApi.reducer,
  [feeDataApi.reducerPath]: feeDataApi.reducer,
})
